import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  startGetArchivos,
  startGetAsistencia,
} from "../../../context/actions/asistenciasActions";

import { DatosAsistencia } from "./datosAsistencia/DatosAsistencia";
import { Mapa } from "./mapa/Mapa";

export const Detalle = () => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();


  ///
  useEffect(() => {
    dispatch(startGetAsistencia(asistenciaID));
    dispatch(startGetArchivos(asistenciaID));
  }, [dispatch]);

  //////
  return (
    <>
      <DatosAsistencia />
      
      <Mapa />
    </>
  );
};
